import styled from 'styled-components';

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ModalTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  line-height: 28px;
  margin: 0;
`;

export const ModalDescription = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.black9};
  margin: 0;
`;

export const CheckboxContainer = styled.div`
  margin-top: 8px;

  .ant-checkbox-inner {
    border-color: ${({ theme }) => theme.colors.black4};
  }

  &:hover .ant-checkbox-inner {
    border-color: ${({ theme }) => theme.colors.black9};
  }
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${({ theme }) => theme.colors.black9};
    border-color: ${({ theme }) => theme.colors.black9};
  }

  .ant-checkbox-checked:hover .ant-checkbox-inner {
    background-color: ${({ theme }) => theme.colors.black9};
    border-color: ${({ theme }) => theme.colors.black9};
  }

  .ant-checkbox::after {
    border-color: ${({ theme }) => theme.colors.black9};
  }

  .ant-checkbox-checked .ant-checkbox-inner::after {
    border-color: white;
  }

  .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: ${({ theme }) => theme.colors.black9} !important;
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);
  }
`;
